import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-no-br-after',
  templateUrl: './ui-no-br-after.component.html',
  styleUrls: ['./ui-no-br-after.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UiNoBrAfterComponent {
  @Input() after: string = 'md';
  @Input() text: string = '';

  constructor() {
  }
}
